export default __webpack_public_path__ + "static/media/next_page_ico.84c0f829.svg";